import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { IQuote } from '../../interfaces/quote.interface';

@Component({
    selector: 'app-quote-generator',
    templateUrl: './quote-generator.component.html',
    styleUrls: ['./quote-generator.component.scss'],
})
export class QuoteGeneratorComponent implements OnInit {
    public currentQuote: IQuote;

    constructor(private translateService: TranslateService) {}

    public ngOnInit(): void {
        const quotes: string[] = [];
        const authors: string[] = [];
        this.translateService.get('CITATIONS').forEach((c: any) => {
            for (const [, value] of Object.entries(c)) {
                quotes.push(value as string);
            }
        });
        this.translateService.get('AUTEURS').forEach((c: any) => {
            for (const [, value] of Object.entries(c)) {
                authors.push(value as string);
            }
        });
        const i: number = Math.floor(Math.random() * quotes.length);
        this.currentQuote = {
            quote: quotes[i],
            author: authors[i],
        };
    }
}
